const API_TIMEZONE_SUFFIX_PATTERN = /(Z|[+-]\d{2}:?\d{2})$/i

export const parseCard3dsApiDate = (value: string) => {
	const normalizedValue = value.includes("T") ? value : value.replace(" ", "T")
	return new Date(
		API_TIMEZONE_SUFFIX_PATTERN.test(normalizedValue)
			? normalizedValue
			: `${normalizedValue}Z`
	)
}
